import { TravelMode } from "@anw/gor-sdk";

/**
 * Travel modes that represent commercial vehicles and therefore expose the vehicle dimension inputs
 * (length, width, height, weight, axle weight, max speed) in the UI.
 *
 * The routing request must only ever carry dimension measures for these modes — switching to any
 * other mode (e.g. CAR) must not send a stale, previously-entered dimension such as a 4.5 m height.
 * @see gateVehicleParametersByTravelMode
 */
export const VEHICLE_DIMENSION_MODES: TravelMode[] = ["BUS", "VAN", "TRUCK"];

/**
 * Travel modes that expose the hazmat / ADR tunnel restriction inputs in the UI, and therefore the
 * only modes for which those parameters may be sent with a routing request.
 */
export const HAZMAT_ADR_MODES: TravelMode[] = ["TRUCK"];
